import React, { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../../context/ModalContext";
import { convertDateToLocalDate, formatDate } from "../../../utils/date";
import { getMediaImageURL, getMediaURL } from "../../../utils/media";
import MediaPlayer from "./MediaPlayer";
import { useRouter } from 'next/router';

const MultimediaPreview = (props: {
  className?: string,
  media: any
}) => {
  const { handleModal } = useContext(ModalContext) as unknown as {
    handleModal: (modalContent: JSX.Element) => void,
  };
  const [hover, setHover] = useState(false);
  const [thumbnail, setThumbnail] = useState<string | null>(null);
  const router = useRouter();

  const modalContent = (
    <div>
      <MediaPlayer
        url={ getMediaURL(props.media) }
        autoplay={true}
      />
      <div className="p-5">
        <h3 className="text-xl">{ props.media.title }</h3>
        <p className="font-light">{ props.media.caption }</p>
      </div>
    </div>
  )

  const handleClick = (e) => {
    const { term, category } = router.query;
    const param = term ? `?term=${term}` : category ? `?category=${category}` : "";
    e.preventDefault();
    router.push(`/multimedia`, `/multimedia/${props.media.slug}${param}`, { shallow: true })
    if(handleModal) {
      handleModal(modalContent)

    }
  }

  useEffect(() => {
    const getThumbnail = async () => {
      if(props.media) {
        const thumbnailUrl = await getMediaImageURL(props.media);
        setThumbnail(thumbnailUrl);
      }
    }
    getThumbnail();
  }, [props.media]);

  return (
    <div
      className={`rounded article-container shadow-lg flex flex-col overflow-hidden cursor-pointer relative ${ props.className }`}
      onClick={handleClick}
      onMouseEnter={() => {
        setHover(true)
      }}
      onMouseLeave={() => {
        setHover(false)
      }}
      onKeyDown={(e) => {
        if(e.key === 'Enter') {
          handleClick(e);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="View Media"
    >
      <div className="relative overflow-hidden">
      {!thumbnail ? (
          <div className="article-image bg-cover bg-center h-0 aspect-16/9 hover"></div>
        ) : (
          <div
            className="article-image bg-cover bg-center h-0 aspect-16/9 hover"
            style={{
              backgroundImage: `url("${thumbnail}")`,
            }}
          >
            <div
              className={`absolute inset-0 bg-black bg-opacity-60 transition-all text-shadow text-white flex items-center justify-center ${
                hover ? "opacity-100" : "opacity-0"
              }`}
            >
              Click to Play Video
            </div>
          </div>
        )}
      </div> 
      <div className="p-6 flex flex-col">
        <div className="flex-1">
          <p className="font-normal text-sm opacity-60 pb-2">
            { props.media.date && formatDate(convertDateToLocalDate(props.media.date)) }
          </p>
          <h2 className="transition-all text-base font-bold">
            { props.media.title }
          </h2>
        </div>
      </div>
    </div>
  )
}

export default MultimediaPreview;
